import React from 'react';
import { Search } from 'lucide-react';

interface SidebarSearchButtonProps {
  onClick: () => void;
}

export const SidebarSearchButton: React.FC<SidebarSearchButtonProps> = ({ onClick }) => {
  return (
    <div className="px-4 py-3">
      <button
        onClick={onClick}
        className="w-full flex items-center gap-2 rounded-md py-2 px-2.5 text-13 bg-neutral-200/60 hover:bg-white hover:shadow-sm border border-transparent hover:border-neutral-200 text-neutral-500 transition"
      >
        <Search className="w-4 h-4" />
        <span className="flex-1 text-left">Search...</span>
        <div className="flex items-center gap-0.5">
          <kbd className="px-1 py-0.5 text-2xs font-medium bg-white/80 rounded border border-neutral-200/80">⌘</kbd>
          <kbd className="px-1 py-0.5 text-2xs font-medium bg-white/80 rounded border border-neutral-200/80">K</kbd>
        </div>
      </button>
    </div>
  );
};
